import * as React from "react";

import { IDispatchAction, IUserState } from "../types";
import { getLocalStorage } from "../api";

interface IUserContextProps {
  state: IUserState;
  dispatch: React.Dispatch<IDispatchAction<any>>;
}

const initialState: IUserState = {
  successMessage: "",
  errorMessage: "",
  user: getLocalStorage("user"),
  currentEntity: getLocalStorage("currentEntity"),
  reconset: {
    entityId: "",
    id: "",
    queryColumns: [],
    queryColumnsValue: [],
    queryColumnsLOV: [],
  },
  useCase: {
    entityId: "",
    id: "",
    runId: "",
    access: "*",
  },
};

export const UserContext = React.createContext<IUserContextProps>({
  state: initialState,
  dispatch: () => {},
});
